/* unplugin-vue-components disabled */import script from "./SaveRecruitNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./SaveRecruitNotice.vue?vue&type=script&setup=true&lang=js"

import "./SaveRecruitNotice.vue?vue&type=style&index=0&id=6b2c3994&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b2c3994"]])

export default __exports__